<div class="address__page container zk-pb-20">
	<div class="address_header zk-pb-5">
		<div class="zk-pt-5 zk-pb-4">
			<div
				(click)="onBackPage()"
				class="cursor-pointer zk-w-20 zk-flex zk-gap-1 zk-items-center"
			>
				<span class="freud-icon freud-icon-arrow-left"></span>
				<span>{{ 'PAGES.ADDRESS.BACK' | translate }}</span>
			</div>
		</div>
		<div class="zk-flex zk-justify-between zk-items-center">
			<span class="address__title" freud-typography fontType="h2BoldAuto">{{
				action === 'create'
					? ('PAGES.ADDRESS.TITLE_NEW' | translate)
					: ('PAGES.ADDRESS.TITLE_EDIT' | translate)
			}}</span>
			<div class="zk-hidden zk-gap-4 md:zk-flex">
				<freud-button (click)="saveAddress()" [loading]="isLoading">{{
					'PAGES.ADDRESS.SAVE' | translate
				}}</freud-button>
				<freud-button color="secondary" (click)="confirmCancel()">{{
					'PAGES.ADDRESS.CANCEL' | translate
				}}</freud-button>
			</div>
		</div>
	</div>
	<div class="address_body zk-flex zk-flex-col md:zk-flex-row zk-gap-10">
		<freud-card class="address__form md:zk-w-3/5">
			<span
				freud-typography
				fontType="h4SemiboldAuto"
				class="form__title zk-pb-4 zk-block"
				>{{ 'PAGES.ADDRESS.ADDRESS' | translate }}</span
			>
			<address-form
				[initialValue]="initialValue"
				[action]="action"
				(onFormInit)="setFormInstance($event)"
			></address-form>
		</freud-card>
		<div class="md:zk-w-2/5 zk-flex zk-flex-col zk-gap-6">
			<address-particular-price
				[price]="price"
				[action]="action"
				[canUpdatePrice]="canUpdatePrice"
				[title]="'PAGES.ADDRESS.PARTICULAR_PRICE' | translate"
				(onChange)="onChangeParticularPrice($event)"
			></address-particular-price>
			<!-- <address-coorporative-price
				(onChanges)="onChangesTiers($event)"
				[initialValue]="tiers"
				[title]="'PAGES.ADDRESS.CORPORATIVE_PRICE' | translate"
			></address-coorporative-price> -->
		</div>
	</div>
	<div class="zk-flex zk-gap-4 zk-mt-4 md:zk-hidden zk-justify-center">
		<freud-button (click)="saveAddress()" [loading]="isLoading">{{
			'PAGES.ADDRESS.SAVE' | translate
		}}</freud-button>
		<freud-button color="secondary" (click)="confirmCancel()">{{
			'PAGES.ADDRESS.CANCEL' | translate
		}}</freud-button>
	</div>
</div>
<freud-dialog
	[modal]="true"
	header="{{ 'PAGES.ADDRESS.EXIT_TITLE' | translate }}"
	[(visible)]="isConfirmCancelModalOpen"
>
	<p>{{ 'PAGES.ADDRESS.EXIT_PAGE_MESSAGE' | translate }}</p>

	<ng-container freudTemplatefooter>
		<freud-button color="secondary" (click)="backToAccountPage()">{{
			'PAGES.ADDRESS.CANCEL_EDIT' | translate
		}}</freud-button>
		<freud-button (click)="isConfirmCancelModalOpen = false">{{
			'PAGES.ADDRESS.CONTINUE_EDIT' | translate
		}}</freud-button>
	</ng-container>
</freud-dialog>
